<template>
    <!-- v-show is required to prevent CLS for ssr -->
    <div class="cookie-bar out" v-show="!$ceres.isSSR" :class="{ 'in': isVisible }">
        <div class="container" v-if="isVisible">
            <div class="row pt-3" v-show="!isExpanded" :class="classes" :style="styles">
                <div class="col-12 text-center">
                    <span class="h2">Datenschutz-Einstellungen</span>
                    <p>
                        Wir und unsere Partner verarbeiten Ihre persönlichen Daten mit Hilfe von Cookies
                        sowie ähnlichen Technologien, um Informationen auf Ihrem Gerät zu speichern, für personalisierte 
                        Werbung und Inhalte, zur Messungen von Werbung und Inhalten und zur Weiterentwicklung unserer 
                        Angebote.
                        Sie haben die Möglichkeit, selbst zu bestimmen, welche Daten erfasst werden sollen. Mit einem
                        Klick auf "Einverstanden" akzeptieren Sie alle Cookies und gelangen direkt zur Website.
                        Alternativ können Sie unter "Einstellungen" eine ausführliche Beschreibung der
                        eingesetzten Cookies und ihrer Verwendungszwecke einsehen und Ihre Präferenzen entsprechend
                        anpassen. Sollten Sie auf ein personalisiertes Einkaufserlebnis verzichten wollen, klicken Sie
                        bitte <a @click="storeConsents(); close()">hier</a>. Ihre Einwilligung ist freiwillig und kann
                        jederzeit über die Datenschutz-Einstellungen widerrufen oder geändert werden. </p>
                    <p>
                        <a class="d-inline-block read_more"
                            href="/privacy-policy/">Daten­schutz­erklärung</a> | <a
                            class="d-inline-block read_more" href="/legal-disclosure/">{{
                            $translate("Ceres::Template.legalDisclosure") }}</a>
                    </p>
                </div>
                <div class="col-12 col-md-12 text-center pb-4 pt-1">
                    <button @click.prevent.stop="isExpanded = true"
                        class="btn btn-default btn-appearance d-inline-block">Einstellungen</button>
                    <button onclick="consentGiven(window.ConsentManager.hasResponse())"
                        class="btn btn-primary btn-appearance d-inline-block" @click="acceptAll(); close()"
                        v-html="'Einverstanden, zum Shop &rarr;'"></button>
                </div>

            </div>
            <div class="row privacy-details" v-if="isExpanded" :class="classes" :style="styles">
                <div class="col-12 mb-3">
                    <privacy-settings :consent-groups="consentGroups"></privacy-settings>
                </div>
                <div class="col-12 col-md-12 text-center">
                    <button onclick="consentGiven(window.ConsentManager.hasResponse())"
                        v-html="$translate('Ceres::Template.cookieBarSave')" class="btn btn-default mr-2"
                        @click="storeConsents(); close()"></button>
                    <button onclick="consentGiven(window.ConsentManager.hasResponse())"
                        class="btn btn-primary btn-appearance cookiesAccept"
                        v-html='$translate("Ceres::Template.cookieBarAcceptAll")'
                        @click="acceptAll(); close()"></button>
                </div>
                <div class="col-12 col-md-6">
                    <a class="text-appearance d-inline-block mb-3" v-html="$translate('Ceres::Template.cookieBarBack')"
                        @click.prevent.stop="isExpanded = false"></a>
                </div>
            </div>
        </div>

        <div v-else>
            <a @click.prevent.stop="isCollapsed = false"
                :aria-label="$translate('Ceres::Template.cookieBarPrivacySettings')">
                <i class="fa fa-shield float-none" aria-hidden="true"></i>
                <span class="d-inline-block" v-html="$translate('Ceres::Template.cookieBarPrivacySettings')"></span>
            </a>
        </div>
    </div>
</template>

<script>
import { mapMutations } from "vuex";
import { ComponentIdMixin } from "../../mixins/componentId.mixin";

export default {
    props:
    {
        styles: String,
        classes: String,
        consentGroups: Object,
        showRejectAll: {
            type: Boolean,
            default: true
        }
    },

    mixins: [ComponentIdMixin], // Experimental mixin, may be removed in the future.

    data()
    {
        return {
            isCollapsed: true,
            isExpanded: false
        };
    },

    computed:
    {
        isVisible()
        {
            return App.isShopBuilder || !this.$store.state.consents.hasResponse || !this.isCollapsed;
        },

        isShopBuilder()
        {
            return App.isShopBuilder;
        },

        text()
        {
            const links = {
                gtc: "<a class=\"text-appearance\" href=\"" + App.urls.gtc + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutGtc") + "</a>",
                cancellation: "<a class=\"text-appearance\" href=\"" + App.urls.cancellationRights + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutCancellationRight", {"hyphen": "&shy;"}) + "</a>",
                policy: "<a class=\"text-appearance\" href=\"" + App.urls.privacyPolicy + "\" target=\"_blank\">" + this.$translate("Ceres::Template.checkoutPrivacyPolicy", {"hyphen": "&shy;"}) + "</a>",
                legal: "<a class=\"text-appearance\" href=\"" + App.urls.legalDisclosure + "\" target=\"_blank\">" + this.$translate('Ceres::Template.footerLegalDisclosure') + "</a>"
            };

            return this.$translate("Ceres::Template.cookieBarHintText", links);
        }
    },

    methods:
    {
        ...mapMutations([
            "storeConsents",
            "acceptAll",
            "denyAll"
        ]),

        close()
        {
            gtag('consent', 'update', { 'ad_storage': (window.ConsentManager.isConsented('tracking.GAds') ? 'granted' : 'denied') });
            gtag('consent', 'update', { 'ad_user_data': (window.ConsentManager.isConsented('tracking.GAds') ? 'granted' : 'denied') });
            gtag('consent', 'update', { 'ad_personalization': (window.ConsentManager.isConsented('tracking.GAds') ? 'granted' : 'denied') });
            gtag('consent', 'update', { 'analytics_storage': (window.ConsentManager.isConsented('tracking.GAnl') ? 'granted' : 'denied') }); 

            this.isCollapsed = true;
            this.isExpanded = false;
        },

        open()
        {
            this.isCollapsed = false;
        },

        isConsented(groupKey)
        {
            return this.$store.getters.isConsented(groupKey + ".*");
        },

        toggleConsent(groupKey)
        {
            this.$store.commit("toggleConsent", groupKey + ".*");
        }
    }
}
</script>
